import React from "react";
import Text from "../../genericComponents/Text";
import styled from 'styled-components';
import {
  Chart,
  BarSeries,
  ArgumentAxis,
} from "@devexpress/dx-react-chart-material-ui";

export default React.memo(function MyComponent({simulationData,t}) {
  const minspl=simulationData.minspl;
  const maxspl=simulationData.maxspl;
  const pointsFactor = simulationData.pointsNumx*simulationData.pointsNumy;
  const step = (maxspl-minspl)/8;
  const halfstep = step/2;
  const step1 = minspl+step;
  const step2 = step1+step;
  const step3 = step2+step;
  const step4 = step3+step;
  const step5 = step4+step;
  const step6 = step5+step;
  const step7 = step6+step;
  const quantityData = Array(8).fill(0);
  simulationData?.soundPressure?.forEach(r=>{
    r.forEach((r2,i) => {
      if(r2>step7)return quantityData[7]++;
      if(r2>step6)return quantityData[6]++;
      if(r2>step5)return quantityData[5]++;
      if(r2>step4)return quantityData[4]++;
      if(r2>step3)return quantityData[3]++;
      if(r2>step2)return quantityData[2]++;
      if(r2>step1)return quantityData[1]++;
      else return quantityData[0]++;
    });
  });
  const data = [
    { spl: `${Number(minspl+halfstep).toFixed(1)}`, percent: quantityData[0]/pointsFactor },
    { spl: `${Number(step1+halfstep).toFixed(1)}`, percent: quantityData[1]/pointsFactor },
    { spl: `${Number(step2+halfstep).toFixed(1)}`, percent: quantityData[2]/pointsFactor },
    { spl: `${Number(step3+halfstep).toFixed(1)}`, percent: quantityData[3]/pointsFactor },
    { spl: `${Number(step4+halfstep).toFixed(1)}`, percent: quantityData[4]/pointsFactor },
    { spl: `${Number(step5+halfstep).toFixed(1)}`, percent: quantityData[5]/pointsFactor },
    { spl: `${Number(step6+halfstep).toFixed(1)}`, percent: quantityData[6]/pointsFactor },
    { spl: `${Number(step7+halfstep).toFixed(1)}`, percent: quantityData[7]/pointsFactor }
  ];

  const maxnum = Math.max(...data.map(o=>o.percent));
  const rest = (0.05-maxnum%0.05)*550;
  const scale = Array(parseInt(maxnum/0.05)+2).fill('');

  return(
    <ChartContainer>
      <Text id={'rotetedtext'} titleSize={1} titleLevel={4}>{t('normalize_distribution')}</Text>
      <Text titleSize={1} titleLevel={4} style={{position:'absolute',top:230,left:660}}>(dB)</Text>
      <div style={{display:"flex",height:235+rest,bottom:24,left:28,position:'absolute',flexDirection:'column-reverse',justifyContent:'space-between'}}>
        {scale.map((_,i)=><Text titleSize={0} titleLevel={4}>{i*5}</Text>)}
      </div>
      <div style={{width:16}}/>
      <Chart height={260} width={600} data={data} >
        <ArgumentAxis/>
        <BarSeries valueField="percent" argumentField="spl" barWidth={0.7} />
      </Chart>  
      <SPLLimitsContainer>
        <Text titleSize={1} titleLevel={4} strong>MAX SPL</Text>
        <Text titleSize={2} titleLevel={4} strong>{Number(simulationData.maxspl).toFixed(1)} dB</Text>
        <div style={{width:100,height:50}}/>
        <Text titleSize={1} titleLevel={4} strong>MIN SPL</Text>
        <Text titleSize={2} titleLevel={4} strong>{Number(simulationData.minspl).toFixed(1)} dB</Text>
      </SPLLimitsContainer>
    </ChartContainer>
  );
},);


const ChartContainer= styled.div`
  position: relative;
  padding-left: 20px;
  display: flex;
  flex-direction: row;
  margin-top: 24px;
  #rotetedtext{
    position: absolute;
    transform-origin: 0 0;
    transform: rotate(-90deg) translateY(-20px) translateX(-220px);
  }
  justify-self: '';
`;
const SPLLimitsContainer = styled.div`
  display:flex;
  flex-direction:column;
  align-items:center;
  height: 100%;
  min-width: 80px;
`;